var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmsNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.1654 27.9999V41.3333C59.1654 50.6666 53.832 54.6666 45.832 54.6666H19.1654C11.1654 54.6666 5.83203 50.6666 5.83203 41.3333V22.6666C5.83203 13.3333 11.1654 9.33325 19.1654 9.33325H37.832",
    stroke: "#1373E7",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.168 24L27.5146 30.6667C30.2613 32.8533 34.768 32.8533 37.5146 30.6667L40.6613 28.16",
    stroke: "#1373E7",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4987 21.3333C56.1806 21.3333 59.1654 18.3486 59.1654 14.6667C59.1654 10.9848 56.1806 8 52.4987 8C48.8168 8 45.832 10.9848 45.832 14.6667C45.832 18.3486 48.8168 21.3333 52.4987 21.3333Z",
    stroke: "#1373E7",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmsNotification);
export default __webpack_public_path__ + "static/media/sms_notification.51cfd1e6ae47f8c80f8b0531aad8009c.svg";
export { ForwardRef as ReactComponent };